export default {
    'name': 'magnifier',
    'width': '16',
    'height': '16',
    'viewBox': '0 0 16 16',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M2.5 7.25C2.5 4.62665 4.62665 2.5 7.25 2.5C9.87335 2.5 12 4.62665 12 7.25C12 9.87335 9.87335 12 7.25 12C4.62665 12 2.5 9.87335 2.5 7.25ZM7.25 1.5C4.07436 1.5 1.5 4.07436 1.5 7.25C1.5 10.4256 4.07436 13 7.25 13C8.65771 13 9.94726 12.4941 10.9468 11.6543L13.6461 14.3536C13.8414 14.5489 14.158 14.5489 14.3532 14.3536C14.5485 14.1584 14.5485 13.8418 14.3532 13.6465L11.6539 10.9472C12.494 9.94761 13 8.65789 13 7.25C13 4.07436 10.4256 1.5 7.25 1.5Z\' fill=\'#42A463\'/>'
}
